import type { UserRole } from '@/constants'
import { USER_ROLE_KEYS, enumLabel } from '@/constants/enums'

const DISPLAY_TO_KEY: Record<string, UserRole> = {
  'システム管理者': 'SYSTEM_ADMIN',
  '管理者': 'ADMIN',
  '業務センター': 'BUSINESS_CENTER',
  '受付窓口': 'RECEPTION_COUNTER',
  'コールセンター（SV）': 'CALL_CENTER_SV',
  'コールセンター(SV)': 'CALL_CENTER_SV',
  'コールセンター（一般）': 'CALL_CENTER_AGENT',
  'コールセンター(一般)': 'CALL_CENTER_AGENT',
  '自治体職員': 'MUNICIPALITY_STAFF',
}

const ROLE_KEY_SET = new Set<string>(USER_ROLE_KEYS)

/** 表示名 / enum キーのどちらが来ても UserRole キーに正規化する。 */
export function roleDisplayToApi(role: string): UserRole {
  const normalized = (role ?? '').trim()
  if (ROLE_KEY_SET.has(normalized)) return normalized as UserRole
  return DISPLAY_TO_KEY[normalized] ?? 'BUSINESS_CENTER'
}

export function roleApiToDisplay(role: UserRole | string): string {
  const key = ROLE_KEY_SET.has(role) ? role : roleDisplayToApi(role)
  return enumLabel('roles', key) || key
}

export function statusDisplayToApi(status: string): 'ACTIVE' | 'INACTIVE' {
  const normalized = (status ?? '').trim()
  if (normalized === '無効' || normalized === 'INACTIVE') {
    return 'INACTIVE'
  }
  return 'ACTIVE'
}
